export const LOAN_QUERY_TYPE_OPTIONS = ['exact', 'included', 'start with'] as const

export type LoanQueryType = (typeof LOAN_QUERY_TYPE_OPTIONS)[number]

export const DEFAULT_LOAN_QUERY_TYPE: LoanQueryType = 'start with'
